import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { Link, Element } from 'react-scroll';
import { noneStyle } from '../../helpers/common';
import { propArrayShape, propBool, propFunc, propNumber, propShape, } from '../../helpers/custom-prop-types';
import FaqContentItem from './FaqContentItem';
const FaqContent = (props) => {
    const { changeIsShow, isShow, items, onLinkClick, showQuestions, tabNo } = props;
    return (_jsxs("section", Object.assign({ className: 'tab-content', style: isShow ? {} : noneStyle }, { children: [_jsx("nav", Object.assign({ className: 'tab-page-link' }, { children: _jsx("ul", { children: items.map((item) => (_jsx("li", { children: _jsxs(Link, Object.assign({ className: 'text-link page-link', duration: 500, offset: -70, smooth: true, to: `${tabNo}_${item.middle}` }, { children: [item.middle, _jsx("i", Object.assign({ className: 'material-icons' }, { children: "keyboard_arrow_down" }))] })) }, item.middle))) }) })), items.map((item) => (_jsxs(Element, Object.assign({ className: 'content-box', name: `${tabNo}_${item.middle}` }, { children: [_jsx("h3", { children: item.middle }), item.contents.map((row) => (_jsx(FaqContentItem, { changeIsShow: changeIsShow, isShow: showQuestions[row.question], item: row, onLinkClick: onLinkClick, tabNo: tabNo }, row.question)))] }), `${tabNo}_${item.middle}`)))] })));
};
FaqContent.defaultProps = {
    onLinkClick: () => { },
};
FaqContent.propTypes = {
    changeIsShow: propFunc().isRequired,
    isShow: propBool().isRequired,
    items: propArrayShape().isRequired,
    onLinkClick: propFunc(),
    showQuestions: propShape().isRequired,
    tabNo: propNumber().isRequired,
};
export default FaqContent;
